export const CREDITOS_ADICIONAIS = 'CREDITOS_ADICIONAIS';
export const CREDITOS_ADICIONAIS_START = 'CREDITOS_ADICIONAIS_START';
export const CREDITOS_ADICIONAIS_SUCCESS = 'CREDITOS_ADICIONAIS_SUCCESS';
export const CREDITOS_ADICIONAIS_ERROR = 'CREDITOS_ADICIONAIS_ERROR';
